import type {
  BankAccountDTO,
  AllBankAccountsResponseDTO,
} from "../models/allBankAccountsDto";
import type { BankAccountEntity } from "../../domain/entities/BankAccountEntity";
import type { AllBankAccountsEntity } from "../../domain/entities/AllBankAccountsEntity";

const FIXED_DEPOSIT_TYPE = "fixed_deposit";
const BANK_ACCOUNT_TYPE = "bank";

function bankAccountDtoToEntity(dto: BankAccountDTO): BankAccountEntity {
  return {
    id: dto.id,
    bankName: dto.bank_name,
    accountType: dto.account_type,
    balance: dto.balance,
    bankBalance: dto.bank_balance,
    isActive: dto.is_active,
    isPrimaryAccount: dto.is_primary_account,
    currencyCode: dto.currency_code,
    zohoBankAccountId: dto.zoho_bankaccountid ?? null,
    pendingTransactionsCount: dto.pending_transactions_count ?? 0,
  };
}

/**
 * Maps API response to domain entity.
 * bankAccounts = operating bank rows only (account_type bank); excludes credit cards and fixed deposits.
 * totalAvailableCash = sum of bankAccounts balances only.
 */
export function allBankAccountsDtoToEntity(
  dto: AllBankAccountsResponseDTO,
): AllBankAccountsEntity {
  const entities = dto.accounts.map(bankAccountDtoToEntity);
  const fixedDeposits = entities.filter(
    (acc) => acc.accountType.toLowerCase() === FIXED_DEPOSIT_TYPE,
  );
  const bankAccounts = entities.filter(
    (acc) => acc.accountType.toLowerCase() === BANK_ACCOUNT_TYPE,
  );
  const totalAvailableCash = bankAccounts.reduce(
    (sum, acc) => sum + acc.balance,
    0,
  );
  return {
    totalAvailableCash,
    bankAccounts,
    fixedDeposits,
  };
}
